var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEverhourLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "124.000000pt",
    height: "124.000000pt",
    viewBox: "0 0 124.000000 124.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,124.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545 1210 c-200 -30 -361 -146 -449 -321 -169 -335 6 -728 369 -835 81 -24 230 -24 310 0 214 64 368 223 421 436 21 84 14 229 -15 322 -44 137 -160 272 -291 338 -101 51 -244 76 -345 60z m233 -116 c201 -66 329 -237 340 -452 4 -82 1 -104 -22 -176 -70 -213 -252 -346 -476 -346 -267 0 -480 199 -497 466 -10 149 39 277 146 385 103 103 208 148 349 148 63 1 101 -5 160 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581 948 c-15 -40 14 -74 54 -64 52 13 38 86 -16 86 -22 0 -32 -6 -38 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 872 c-22 -24 -21 -45 1 -65 25 -23 48 -21 66 5 20 29 20 34 -4 58 -25 25 -42 25 -63 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719 770 c-74 -61 -137 -119 -141 -129 -8 -23 17 -61 41 -61 20 0 61 42 157 160 102 126 98 120 87 131 -6 6 -55 -28 -144 -101z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287 663 c-13 -12 -7 -60 8 -73 38 -31 96 27 65 65 -13 15 -61 21 -73 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878 645 c-9 -21 -8 -28 7 -45 24 -27 51 -25 70 4 23 34 5 66 -36 66 -22 0 -32 -6 -41 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 440 c-27 -50 32 -92 73 -52 18 18 19 25 9 47 -15 32 -66 35 -82 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796 438 c-13 -19 -14 -25 -2 -43 21 -31 68 -27 80 7 18 52 -46 82 -78 36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598 368 c-26 -22 -29 -47 -8 -68 26 -26 45 -25 64 2 20 29 20 34 -4 58 -23 23 -31 24 -52 8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEverhourLogo);
export default __webpack_public_path__ + "static/media/EverhourLogo.2d71f6a703e8c42425592dcd8dca9769.svg";
export { ForwardRef as ReactComponent };